import React from 'react';

import Spinner from '../Spinner/index.jsx';

import LikeIcon from './icons/Like.jsx';
import HeartIcon from './icons/Heart.jsx';
import FaceIcon from './icons/Face.jsx';
import DislikeIcon from './icons/Dislike.jsx';

class ReactionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      busy: false
    };
    this.addReaction = this.addReaction.bind(this)
    this.getIcon = this.getIcon.bind(this)
  }

  addReaction(type)
  {
    if (this.state.busy) return;

    // if (this.props.article.reactions.user[type] === true) return;

    this.setState({
      busy: true
    })

    fetch(`${window.SBM.ajaxUrl}?action=theme:post-reaction`,{
        method: 'post',
        body: JSON.stringify({
          id: this.props.article.id,
          type: type
        })
      })
      .then(response => response.json())
      .then(data => {
        if(data.error) {
          console.error(data.message)
        } else {
          this.props.onReactionUpdate(data.data)
        }
        // set 
        this.setState({
          busy: false
        })
      })

    // Send analytics data to GTM
    let properties = Object.assign({}, this.props.article.analytics)
    properties["content_feedback"] = type;
    CSAnalytics("Content Feedback Given", properties)
  }

  getIcon(type,user) {
    switch(type){
      case 'like': return (<LikeIcon user={user}/>);
      case 'heart': return (<HeartIcon user={user}/>);
      case 'shock': return (<FaceIcon user={user}/>);
      case 'dislike': return (<DislikeIcon user={user}/>);
      default: return type;
    }
  }

  render() {
    return (
      <div  className="cs-article-reactions__action" onClick={()=>{this.addReaction(this.props.type)}}>
        <div className="cs-article-reactions__button">{this.getIcon(this.props.type,this.props.article.reactions.user)}</div>
        {
          this.state.busy ? (
            <Spinner/>
          ) : (
            <div className="cs-article-reactions__value">{this.props.article.reactions.value[this.props.type]||"0"}</div>
          )
        }
      </div>
    );
  }
}

export default ReactionItem;

